export function isAgrCondition(entity: Record<string, unknown>): boolean {
  return !!entity?.isLinkedToAggregator || !!entity?.parentPropertyTicker;
}
